export const queryKeys = {
  personSkills: () => ["personSkills"],
  employment: () => ["employment"],
  accountProfile: () => ["accountProfile"],
  resumePresentation: (careerId) => ["resumePresentation", careerId],
  personNotices: () => ["personNotices"],
  connections: () => ["connections"],
  careers: () => ["careers"],
  sessionShell: () => ["sessionShell"],
};
